import { AppRouter } from './routes/AppRouter';

function App() {
  return (
    <div style={{ width: '100%' }}>
      <AppRouter />
    </div>
  );
}

export default App;
